import { scrollToAppTop } from './scroll-to';
import { isInEditor } from './view-mode';

export default function scrollOnHistoryChange(history) {
  let lastLocation = {};
  history.listen(location => {
    if (isInEditor()) {
      return;
    }

    if (lastLocation.pathname && lastLocation.pathname !== location.pathname) {
      scrollToAppTop();
    }
    lastLocation = location;
  });
}



// WEBPACK FOOTER //
// ./app/services/scroll-on-history-change.js